import { Moment } from 'moment';
import moment from 'moment';

export const convertDateToMoment = (
  date?: string | Date | Moment | null
): Moment | null => {
  if (!date) return null;

  if (moment.isMoment(date)) {
    return date.isValid() ? date : null;
  }

  const momentDate = moment(date);
  if (!momentDate.isValid()) {
    return null;
  }

  return momentDate;
};

export const convertDateToISOString = (
  date?: string | Date | Moment | null
): string | null => {
  const momentDate = convertDateToMoment(date);
  if (!momentDate) return null;
  return momentDate.toISOString();
};

export const convertDateToDateObject = (
  date?: string | Date | Moment | null
): Date | null => {
  const momentDate = convertDateToMoment(date);
  if (!momentDate) return null;
  return momentDate.toDate();
};
